import { CSSProperties } from "react";

export const timeline_contentStyle: CSSProperties = {
  fontFamily: "Lexend",
  fontStyle: "normal",
  fontWeight: 400,
  fontSize: "12px",
  lineHeight: "15px",
  color: "#082247",
  display: "flex",
  alignItems: "center",
  marginLeft: "150px",
  padding: "14px",
  gap: "10px",
  border: "1px solid #E7E8EA",
  boxShadow: "none",
  borderRadius: "12px",
};

export const iconStyle: CSSProperties = {
  width: "40px",
  height: "40px",
  display: "flex",
  background: "white",
  boxShadow: "none",
  border: "1px solid #E7E8EA",
  padding: "5px",
  marginTop: "10px",
};
